<template>
  <div class="faq-and-support">
    <div class="container">
      <div class="faq-and-support__head">
        <div class="faq-and-support__head-left faq-and-support__card">
          <h1 class="faq-and-support__head-left-title">Поддержка</h1>
          <div class="faq-and-support__head-left-text">
            Мы рядом 24 часа, 7 дней в неделю
          </div>
        </div>
        <div class="faq-and-support__head-right faq-and-support__card">
          <div class="faq-and-support__head-right-image">
            <picture>
              <source
                srcset="~/assets/img/faq_and_support/support.webp"
                type="image/webp"
              />
              <img
                src="~/assets/img/faq_and_support/support.jpg"
                width="624"
                height="339"
              />
            </picture>
          </div>
        </div>
      </div>

      <FaqAndSupportContacts />
      <FaqAndSupportDirectionsDesktop />
      <FaqAndSupportChannelsTabs />

      <div class="faq-and-support__questions">
        <h2 class="faq-and-support__subtitle faq-and-support__questions-title">
          Популярные вопросы
        </h2>

        <ul class="faq-and-support__questions-list">
          <li
            v-for="item in questions"
            :key="item.id"
            class="faq-and-support__questions-list-item"
          >
            <a
              :href="item.url"
              target="_blank"
              class="faq-and-support__questions-list-item-link"
            >
              <span>{{ item.title }}</span>

              <VIconMTS
                :name="'mts/icon-mts--arrow-link'"
                class="faq-and-support__questions-list-item-link-img"
                width="16"
                height="16"
                fill="#1d2023"
              />
            </a>
          </li>
        </ul>
      </div>
      <FaqAndSupportReviews />
    </div>
  </div>
</template>

<script>
import FaqAndSupportContacts from '@/components/Desktop/FaqAndSupport/Contacts/FaqAndSupportContacts.vue'
import FaqAndSupportReviews from '@/components/Desktop/FaqAndSupport/FaqAndSupportReviews.vue'
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
import FaqAndSupportQuestionListMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportQuestionListMixin'
import FaqAndSupportDirectionsDesktop from '@/components/Desktop/FaqAndSupport/Directions/FaqAndSupportDirectionsDesktop.vue'
import FaqAndSupportChannelsTabs from '@/components/Desktop/FaqAndSupport/Channels/FaqAndSupportChannelsTabs.vue'

export default {
  name: 'FaqAndSupportDesktop',
  components: {
    FaqAndSupportChannelsTabs,
    FaqAndSupportDirectionsDesktop,
    VIconMTS,
    FaqAndSupportContacts,
    FaqAndSupportReviews,
  },
  mixins: [FaqAndSupportQuestionListMixin],
}
</script>
<style lang="scss" scoped>
.faq-and-support {
  padding: 40px 0 120px;
  font-family: $font-mts-compact;
  color: $color-dark-2;

  .container {
    max-width: 1328px;
    padding: 0 32px;
  }

  &__card {
    display: block;
    border-radius: 24px;
    background: $color-white;
    overflow: hidden;
  }

  &__subtitle {
    font-family: $font-mts-wide;
    font-size: 36px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: -0.36px;
  }

  &__head {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
    margin-bottom: 16px;

    &-left {
      color: $color-dark-2;
      padding: 32px;
      min-height: 339px;
      background: $color-white
        url('~assets/img/faq_and_support/background-card.svg') no-repeat 100%
        100%;

      &-title {
        font-family: $font-mts-compact;
        font-size: 36px;
        line-height: 40px;
        font-weight: 500;
        margin-bottom: 16px;
      }

      &-text {
        font-family: $font-mts-compact;
        font-size: 24px;
        font-weight: 400;
        line-height: 32px;
      }
    }

    &-right {
      min-height: 339px;
      &-image {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }

  &__questions {
    max-width: 1128px;
    margin: 0 auto;

    &-title {
      margin-bottom: 40px;
      text-align: center;
    }

    &-list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 16px;
      list-style-type: none;

      &-item {
        padding: 24px 24px 36px;
        min-height: 200px;
        border-radius: 24px;
        transition: 0.3s ease;

        &:hover {
          background: $color-white;

          & .faq-and-support__questions-list-item-link-img {
            opacity: 1;
          }
        }

        &-link {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          text-decoration: none;
          color: inherit;
          height: 100%;
          font-family: $font-mts-wide;
          font-size: 20px;
          font-weight: 500;
          line-height: 27px;
          letter-spacing: -0.2px;

          &-img {
            transition: 0.3s ease;
            opacity: 0;
          }
        }
      }
    }
  }
}
</style>
